/* A sideways row of cards with arrows (blocks/st-setup.liquid, "Complete your setup"; Paulius,
   2026-10-12: "a scrolling thing left and right like on powerlete"). The row itself is a native
   scroller with snap points, so a swipe, a trackpad and the keyboard's own focus move it; the arrows
   move it one card at a time. They show only when the cards overflow, and each is disabled at its
   end. Smooth unless reduced motion is asked for.
   Markup: [data-st-track] (the scroller), [data-st-prev], [data-st-next] and [data-st-nav] (their
   wrapper, hidden until needed). */
if (!customElements.get('st-scroller')) {
  customElements.define(
    'st-scroller',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-st-track]');
        this.prev = this.querySelector('[data-st-prev]');
        this.next = this.querySelector('[data-st-next]');
        this.nav = this.querySelector('[data-st-nav]');
        if (!this.track || !this.prev || !this.next) return;
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.prev.addEventListener('click', () => this.#step(-1), { signal });
        this.next.addEventListener('click', () => this.#step(1), { signal });
        let frame = 0;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => this.#update());
          },
          { signal, passive: true }
        );
        this.observer = new ResizeObserver(() => this.#update());
        this.observer.observe(this.track);
        this.#update();
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }

      // One card and its gap.
      #stepSize() {
        const [a, b] = this.track.children;
        if (!a) return this.track.clientWidth;
        return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
      }

      #step(dir) {
        const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: dir * this.#stepSize(), behavior: calm ? 'auto' : 'smooth' });
      }

      #update() {
        const t = this.track;
        const overflow = t.scrollWidth > t.clientWidth + 2;
        if (this.nav) this.nav.hidden = !overflow;
        this.prev.disabled = t.scrollLeft <= 2;
        this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    }
  );
}
